module.exports = __webpack_public_path__ + "ru.svg?911c03c21a5ddc5df70b61f46589bd5d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ru.svg
// module id = 1591
// module chunks = 0